import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/crispy bites/soda.png";
import BiscuitImg from "../../../assets/products/crispy bites/Soda-Biscuits.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 227,
  },
  {
    grams: 454,
  },
];

export default function SodaProduct() {
  return (
    <>
      <Helmet>
        <title>
          Crispy Soda Crackers – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Crispy Soda Crackers — light, crisp, and ideal for pairing. View pack sizes and global specs."
        />
        <meta
          name="keywords"
          content="Crispy Soda Crackers, BearBitz Soda Crackers"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/crispy-biscuit/soda-crackers"
        />
        <meta property="og:title" content="Crispy Soda Crackers – BearBitz" />
        <meta
          property="og:description"
          content="Light and crispy soda crackers by BearBitz, crafted for quality and export-readiness."
        />
      </Helmet>

      <ProductTemplate
        productTitle="SODA CRACKERS"
        productImage={BisImg}
        description="Crisp, light, and perfectly salted, Soda Biscuits are a wholesome snack choice for any time of the day. Their mild flavor and crunchy texture make them ideal to pair with tea, coffee, or savory toppings."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#916B43"
        sectionBgColor="#EAD0A6"
        productBgcolor="#FFF2DD"
        tableheadBgcolor="#916B43"
        tableBgcolor="#FFF7EA"
        footerBgcolor="#916B43"
      />
    </>
  );
}
